import { useEffect } from 'react';
import envVar from '@availity/env-var';

const essentialsPrefix = envVar({
  prod: '',
  qa: 'qa-',
  test: 'test-',
  local: 'test-',
});

const visitorPrefix = envVar({
  prod: '',
  qa: 'qa-',
  test: 'test-',
  local: 'local-',
});

declare global {
  interface Window {
    pendo?: {
      initialize: (config: {
        visitor: { id: string };
        account: { id: string };
      }) => void;
    };
  }
}

const usePendo = (akaname: string | undefined, usePortalScript = false): void => {
  useEffect(() => {
    if (akaname === undefined || akaname === null) return;
    let visitorId = akaname
    if (akaname !== '') // Anonymous user
      visitorId = usePortalScript ? akaname : visitorPrefix + akaname
    // Create and append Pendo script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    const scriptFile = usePortalScript ? 'api-dev-portal.js' : 'essentials.js';
    script.src = `https://${essentialsPrefix}essentials.availity.com/static/public/appl/shared-essentials-services/pendo/${scriptFile}`;
    script.className = 'optanon-category-C0002';

    script.addEventListener('load', () => {
      const { pendo } = window;
      if (pendo) {
        try {
          // Initialize Pendo with the provided user
          pendo.initialize({
            visitor: {
              id: visitorId,
            },
            account: {
              id: "Availity",
            },
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error during Pendo initialization:', error);
        }
      }
    });

    document.head.appendChild(script);
  }, [akaname, usePortalScript]);
};

export default usePendo;
